import React, {useState} from 'react';
import {ReactComponent as OpenFullScreen} from '../../../../assests/svg/openFullScreen.svg';
import {Grid, IconButton, Typography} from '@mui/material';
import {t} from 'i18next';
import FamilyDateDialog from '../FamilyDateDialog';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import FamilyDateMap from '../../../common/aur-cal-heatmap/FamilyDateMap';
import {useAnalytics} from '../../../../hooks/useAnalytics';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../../../constants/analyticsConstants';

interface EcafamilyDataProps {
  loadFileId: number | undefined;
}

type InertDivProps = React.HTMLAttributes<HTMLDivElement> & {
  inert?: string;
};

const hiddenGridProps: InertDivProps = {
  'aria-hidden': true,
  inert: '',
};

const EcaFamilyData: React.FC<EcafamilyDataProps> = ({loadFileId}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false); // This is for the dialog
  const {projectId, selectedProjectName: projectName} = useSelector(
    (state: RootState) => state.reports
  );
  const {trackGAEvent} = useAnalytics();

  const handleOpenFamilyDate = () => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.ecaHomePage.expandWidget'),
        type: GA_CLICK_TYPES.ICON,
        region: GA_REGIONS.WIDGET_BODY,
        action: t('gaTracking.ecaHomePage.modalLabelwidget', {
          label: t('gaTracking.ecaHomePage.familyDate'),
        }),
      },
    });
    setIsOpen(true);
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
      subPage: {
        subpage_name: t('gaTracking.ecaHomePage.subpageWidget', {
          label: t('gaTracking.ecaHomePage.familyDate'),
        }),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  };

  // Handle closing the dialog
  const handleDocClose = () => {
    setIsOpen(false);
  };

  return (
    <Grid item xs={6}>
      <div className="doc-column">
        <div className="doc-header">
          <div className="d-flex">
            <Typography className="typo-text subhead4_size">
              {t('ecaHomepageModals.ecaBottom.familyDate')} &nbsp;
            </Typography>
            <Typography className="sub-text-count">
              ({t('ecaHomepageModals.ecaBottom.12months')})
            </Typography>
          </div>
          <span id="family-date-expand-hint" className="sr-only">
            {t('eca.ecaHomepage.ecaFamilyDate')}
          </span>
          <IconButton
            size="small"
            onClick={handleOpenFamilyDate}
            className="expand-button"
            aria-label={`${t('ecaHomepageModals.ecaBottom.familyDate')} ${t('buttons.expand')}`}
            aria-describedby='family-date-expand-hint'
          >
            <OpenFullScreen />
          </IconButton>
          {/* FamilyDateDialog is only controlled by the isOpen state */}
          <FamilyDateDialog
            isOpen={isOpen}
            projectId={projectId}
            onClose={handleDocClose}
            loadFileId={loadFileId}
            projectName={projectName}
          />
        </div>
        <div className="family-Data-Graph">
          <FamilyDateMap
            totalMonths={3}
            isOpen={isOpen}
            projectId={projectId}
            loadFileId={loadFileId}
          />
        </div>
      </div>
    </Grid>
  );
};

export default EcaFamilyData;
